import config from '@feature-config/riya/debug/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { SortingHatDebugFeature } from './SortingHatDebugFeature';

const sortingHatDebugFeature: FeatureModule = createFeatureModule(
  config,
  SortingHatDebugFeature,
  'riya/debug'
);

export default sortingHatDebugFeature;
